import axios from "axios";
import { BASE_URL_API } from "constants/constants";
import { checkTokenExpiration } from "contexts/TokenCheck";

export async function loadListExposeAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "interaction-expose-api/get-all", data, {
    headers: {
      Authorization: token,
    },
  });
}
export async function createExposeAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "interaction-expose-api/create", data, {
    headers: {
      Authorization: token,
    },
  });
}
export async function deleteExposeAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "interaction-expose-api/delete", data, {
    headers: {
      Authorization: token,
    },
  });
}
export async function getDetailsExposeAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "interaction-expose-api/get-details", data, {
    headers: {
      Authorization: token,
    },
  });
}
export async function updateExposeAPI(data) {
  const token = await checkTokenExpiration();
  return axios.post(BASE_URL_API + "interaction-expose-api/update", data, {
    headers: {
      Authorization: token,
    },
  });
}
